import { apiClient } from '../api.client';
import type { Course, Progress } from '../../types/course';
import type { PublicCourse } from '../../types/cart';
import type { ICourseService } from '../interfaces/ICourseService';
import { WeeklyStats } from '../../types/stats';

export const courseReal: ICourseService = {
  getCatalog: () => apiClient.get<PublicCourse[]>('/courses'),

  getMyCourses: () => apiClient.get<Course[]>('/courses/mine'),

  getCourse: (courseId: string) =>
    apiClient.get<Course>(`/courses/${courseId}`),

  getProgress: (courseId: string) =>
    apiClient.get<Progress | null>(`/courses/${courseId}/progress`),

  saveProgress: (
    courseId: string,
    lessonId: string,
    secondsWatched: number,
    completed = false
  ) =>
    apiClient.post<void>(`/courses/${courseId}/progress`, {
      lessonId,
      secondsWatched,
      completed,
    }),
  getWeeklyStats: () => apiClient.get<WeeklyStats>('/stats/weekly'),
};
